import React from 'react';
import { GroupInfo, GroupGridRow } from '../GroupHelperComponents';
import { useGetStates } from '../../../hooks/useStatesList';
import { DatePicker, MaskInput, Select, TextField } from '../../../components/ReactHookForm';

export const GroupDetails = () => {
  const { data: states, isLoading } = useGetStates();

  return (
    <>
      <GroupInfo />
      <GroupGridRow>
        <TextField name="planNumber" wrapperClasses="col-span-3" label="Group number" required />
        <TextField name="name" label="Group name" wrapperClasses="col-span-3" required />
        <DatePicker name="start_dt" label="Start Date" wrapperClasses="col-span-2" placeholder="MM/DD/YYYY" required />
        <DatePicker name="end_dt" label="Termination Date" wrapperClasses="col-span-2" placeholder="MM/DD/YYYY" />
      </GroupGridRow>
      <GroupGridRow>
        <TextField
          name="total_lives"
          label="Total lives count"
          wrapperClasses="col-span-3"
          placeholder="Enter lives count"
          type="number"
        />
        <TextField
          name="total_employee"
          label="Total employees count"
          wrapperClasses="col-span-3"
          placeholder="Enter employee count"
          type="number"
        />
        <TextField
          name="instructions"
          label="Special Instructions"
          wrapperClasses="col-span-3"
          placeholder="Please enter instructions"
        />
      </GroupGridRow>
      <GroupGridRow>
        <TextField
          name="contacts.Account.first"
          label="Contact first name"
          wrapperClasses="col-span-3"
          placeholder="Please enter first name"
          required
        />
        <TextField
          name="contacts.Account.last"
          label="Contact last name"
          wrapperClasses="col-span-3"
          placeholder="Please enter last name"
          required
        />
        <MaskInput
          name="contacts.Account.phone"
          label="Contact phone"
          additionalClasses="col-span-3"
          placeholder="Enter phone number"
          required
        />
      </GroupGridRow>
      <GroupGridRow>
        <TextField
          name="contacts.Account.email"
          label="Group contact email"
          wrapperClasses="col-span-3"
          placeholder="Please enter email"
          required
        />
        <TextField name="street1" label="Address line" wrapperClasses="col-span-3" placeholder="Please enter address" />
        <TextField
          name="street2"
          label="Address line 2"
          wrapperClasses="col-span-3"
          placeholder="Please enter address"
        />
      </GroupGridRow>
      <GroupGridRow>
        <TextField name="city" label="City" placeholder="Please enter city" wrapperClasses="col-span-3" />
        <Select
          name="state"
          label="State"
          options={states}
          isLoading={isLoading}
          placeholder="Please select state"
          wrapperClasses="col-span-3"
        />
        <TextField name="zip" label="Zip code" wrapperClasses="col-span-3" placeholder="Please enter zip" />
      </GroupGridRow>
    </>
  );
};
